module.exports = __webpack_public_path__ + "static/media/header_atom_orbit.7d31bb0a.svg";